import useOrganizations from './useOrganizations';

export default function useOrganization(orgId) {
  const { data: organizations = [] } = useOrganizations();
  return organizations.find(({ id }) => id === Number(orgId));
}
